import FlumpObject from "../../general/objects/FlumpObject";
import { audioPlayer } from "../../PhaserExtension";
import * as GameModel from "../../models/GameModel";

export default class PostgameGrover extends FlumpObject
{
    constructor(game, config, library)
    {
        super(game, config, library);
        audioPlayer.onSoundPlayed.add(this.onSoundPlayed, this);
        this.lang = GameModel.data.english ? "eng" : "esp";
    }

    onSoundPlayed(soundName)
    {
        let anim = this.config.triggers[soundName];
        if(anim)
        {
            if(typeof(anim) === "string")
            {
                this.loop(this.keys.idle, true);
                this.playOnce(this.keys[this.lang][anim], true, true);
            }
            else
            {
                this.loop(this.keys.idle, true);
                this.playOnce(this.keys[this.lang][anim[+this.game.device.desktop]], true, true);
            }
        }
    }

    destroy()
    {
        super.destroy(true);
        audioPlayer.onSoundPlayed.remove(this.onSoundPlayed, this);
    }
}
